import { useEffect, useState } from 'react';

import OhsAvailableInspectionFilterModels, {
  AvailableInspectionSearchFilterForm,
} from 'inspection/register/search/OhsAvailableInspectionFilterModels';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import {
  fetchAvailableInspectionListAsync,
  getOhsInspectionList,
} from 'inspection/OhsInspectionSlice';

import { sortSearchOptions } from '../register/search/OhsAvailableInspectionFilterModels';

const defaultForm = {
  sort: JSON.parse(sortSearchOptions[0].value),
  hasSearch: false,
  searchKey: '',
  substringSearch: true,
  page: 1,
  next: undefined,
};
export default function useOhsAvailableInspectionList(allowFetch?: boolean) {
  const dispatch = useAppDispatch();
  const [form, setForm] = useState<AvailableInspectionSearchFilterForm>(defaultForm);

  const { page, buildFilters } = new OhsAvailableInspectionFilterModels(form);

  const availableInspectionListReducer = useAppSelector(getOhsInspectionList);
  const { isLoading, availableInspectionList } = availableInspectionListReducer;

  const fetchAvailableInspectionLists = (newForm: any = form) => {
    const newFilters = new OhsAvailableInspectionFilterModels(newForm);

    const payload = {
      hasSearch: newFilters.hasSearch,
      list: newFilters.hasSearch ? newFilters.searchFilter : newFilters.filter,
      count: newFilters.hasSearch ? newFilters.searchFilterCount : newFilters.filterCount,
    };

    dispatch(fetchAvailableInspectionListAsync(payload));
  };

  const updateFilter = (payload: number | any) => {
    const newParams = buildFilters(payload, availableInspectionList?.pagination?.next);
    setForm(newParams);
  };

  const resetFilters = () => {
    setForm(defaultForm);
  };

  useEffect(() => {
    if (allowFetch) {
      fetchAvailableInspectionLists(form);
    }
  }, [form]);

  return {
    isLoading,
    availableInspectionList,
    currentPage: page,
    setCurrentPage: (value: number) => updateFilter(value),
    updateFilter,
    fetchAvailableInspectionLists,
    resetFilters,

    hasSearch: form.hasSearch,
    searchFilter: form,
    sortSearchOptions,
  } as const;
}
